import { render, staticRenderFns } from "./FansDetail.vue?vue&type=template&id=3c9ec1c0&scoped=true&"
import script from "./FansDetail.vue?vue&type=script&lang=js&"
export * from "./FansDetail.vue?vue&type=script&lang=js&"
import style0 from "./FansDetail.vue?vue&type=style&index=0&id=3c9ec1c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9ec1c0",
  null
  
)

export default component.exports